/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 of 0.5 diluted 100× for RNA = 0.5 × 100 × 40 = 2000 µg/mL.`)
};

const es_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 0.5 diluido 100× para ARN = 0.5 × 100 × 40 = 2000 µg/mL.`)
};

const de_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 von 0,5, 100-fach verdünnt für RNA = 0,5 × 100 × 40 = 2000 µg/mL.`)
};

const nl_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 van 0,5 verdund 100× voor RNA = 0,5 × 100 × 40 = 2000 µg/mL.`)
};

const fr_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 0,5 dilué 100× pour l'ARN = 0,5 × 100 × 40 = 2000 µg/mL.`)
};

const it_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 di 0,5 diluito 100× per RNA = 0,5 × 100 × 40 = 2000 µg/mL.`)
};

const pt_br2_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 0,5 diluído 100× para RNA = 0,5 × 100 × 40 = 2000 µg/mL.`)
};

const pt_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 de 0,5 diluído 100× para ARN = 0,5 × 100 × 40 = 2000 µg/mL.`)
};

const ja_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNAでA260が0.5、100倍希釈 = 0.5 × 100 × 40 = 2000 µg/mL。`)
};

const zh_od_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNA 的 A260 为 0.5，稀释 100 倍：0.5 × 100 × 40 = 2000 µg/mL。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_ex2", locale)
	if (locale === "en") return en_od_ex2(inputs)
	if (locale === "es") return es_od_ex2(inputs)
	if (locale === "de") return de_od_ex2(inputs)
	if (locale === "nl") return nl_od_ex2(inputs)
	if (locale === "fr") return fr_od_ex2(inputs)
	if (locale === "it") return it_od_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_od_ex2(inputs)
	if (locale === "pt") return pt_od_ex2(inputs)
	if (locale === "ja") return ja_od_ex2(inputs)
	return zh_od_ex2(inputs)
};